<div class="content-block">
    <div class="dx-card responsive-paddings">
        <!-- Toolbar -->
        <div class="toolbar" role="banner">
            Wallets
        </div>

        <div style="display: flex; justify-content: space-between;">
            <div>
                <div style="display: flex;">
                    <button> Back</button>
                    <div>
                        <div>
                            Wallet 1
                        </div>
                        <div>
                            accountRef
                        </div>
                    </div>
                </div>

            </div>

            <div>
                <button> Add Money </button>
            </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
            <div>
                <div>
                    Cash Balance 
                </div>
                <div>
                    R 8.0000
                </div>
            </div>

            <div>
                <div>
                    Balane on card: R 2.000
                </div>
                <div>
                    Wallet min. treashold: R 10.00
                </div>
            </div>
        </div>

        <h2>
            Cards
        </h2>

        <div class="content-grid">
            <h2 class="content-block">Cards </h2>
            <!-- <dx-data-grid class="dx-card wide-card" [dataSource]="dataSource" [showBorders]="false" [focusedRowEnabled]="true"
                [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true">
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxi-column dataField="CardName" caption="Card Name"> </dxi-column>
                <dxi-column dataField="CardNumber" caption="Card Number"> </dxi-column>
                <dxi-column dataField="Wallet.Name" caption="Wallet"> </dxi-column>
                <dxi-column dataField="ExpiredDate" caption="ExpiredDate"> </dxi-column>
            </dx-data-grid> -->
        </div>
    </div>
</div>